// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/Button.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/Button.tsx");
  import.meta.hot.lastModified = "1747627379213.2825";
}
// REMIX HMR END

import { Link } from '@remix-run/react';
import { forwardRef } from 'react';
import { cn } from '~/utils/style';
const displayTypeMap = {
  primary: ['text-white', 'bg-[var(--skype-blue)] hover:bg-[var(--skype-blue-hover)] active:bg-[var(--skype-blue-hover)]', 'border-[var(--skype-blue)] hover:border-[var(--skype-blue-hover)] active:border-[var(--skype-blue-hover)]'],
  secondary: ['text-[var(--skype-text)]', 'bg-[var(--skype-gray-100)] hover:bg-[var(--skype-gray-200)] active:bg-[var(--skype-gray-300)]', 'border-[var(--skype-gray-300)] hover:border-[var(--skype-gray-400)]'],
  ghost: ['text-[var(--skype-text)] hover:text-[var(--skype-text)]', 'bg-transparent hover:bg-[var(--skype-gray-100)]', 'border-transparent hover:border-[var(--skype-gray-300)]'],
  danger: ['text-white', 'bg-[var(--skype-error)] hover:bg-[#8A1F24] active:bg-[#6F1A1F]', 'border-[var(--skype-error)] hover:border-[#8A1F24] active:border-[#6F1A1F]']
};
export const Button = forwardRef(_c = ({
  className,
  displayType = 'primary',
  variant = 'default',
  disabled,
  onClick,
  title,
  'aria-label': ariaLabel,
  ...rest
}, ref) => <button className={cn('border-2', 'font-medium', 'transition-colors duration-150', disabled && 'cursor-not-allowed opacity-60', variant === 'default' ? ['rounded-xl', 'py-2 px-4', 'text-sm'] : ['rounded-full', 'w-10 h-10', 'text-base', 'grid place-items-center'], ...displayTypeMap[displayType], className)} aria-disabled={disabled} aria-label={ariaLabel} title={title} // Native tooltip on hover
onClick={disabled ? e => e.preventDefault() : onClick} {...rest} ref={ref} />);
_c2 = Button;
Button.displayName = 'Button';
export const ButtonLink = forwardRef(_c3 = ({
  className,
  displayType = 'primary',
  variant = 'default',
  ...rest
}, ref) =>
// eslint-disable-next-line jsx-a11y/anchor-has-content
<Link className={cn('inline-block', 'border-2', 'font-medium', 'transition-colors duration-150', variant === 'default' ? ['rounded-xl', 'py-2 px-4', 'text-sm'] : ['rounded-full', 'w-10 h-10', 'flex items-center justify-center', 'text-base'], displayTypeMap[displayType].join(' '), className)} {...rest} ref={ref} />);
_c4 = ButtonLink;
ButtonLink.displayName = 'Button';
var _c, _c2, _c3, _c4;
$RefreshReg$(_c, "Button$forwardRef");
$RefreshReg$(_c2, "Button");
$RefreshReg$(_c3, "ButtonLink$forwardRef");
$RefreshReg$(_c4, "ButtonLink");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;